import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { API_CONFIG } from '../config';
import { Auth } from '../services/auth';
import { toApiClientError } from './api-error.mapper';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(Auth);
  const router = inject(Router);

  return next(request).pipe(
    catchError((error: unknown) => {
      const apiError = toApiClientError(error);

      if (apiError.apiError.status === 401 && isApiRequest(request.url)) {
        auth.expireSession();
        void router.navigateByUrl('/login');
      }

      if (apiError.apiError.status === 403 && isApiRequest(request.url) && isSuspendedAccessError(apiError.apiError.message)) {
        auth.setLoginBlockReason('suspended');
        auth.expireSession();
        void router.navigate(['/login'], {
          queryParams: { reason: 'suspended' },
        });
      }

      return throwError(() => apiError);
    }),
  );
};

function isSuspendedAccessError(message: string) {
  const normalizedMessage = message.trim().toLowerCase();
  return normalizedMessage.includes('suspend');
}

function isApiRequest(url: string) {
  try {
    const base = typeof window === 'undefined' ? 'http://localhost' : window.location.origin;
    const resolvedUrl = new URL(url, base);
    return resolvedUrl.pathname === API_CONFIG.basePath || resolvedUrl.pathname.startsWith(`${API_CONFIG.basePath}/`);
  } catch {
    return false;
  }
}
